/**
 * Remembers which friend's link brought someone in, from the moment they arrive
 * with `?ref=CODE` until they sign up. Kept in the browser for 30 days; storage can
 * be blocked, so every access is allowed to fail quietly.
 */
const KEY = "ga_ref";
const KEEP_MS = 30 * 24 * 60 * 60_000;
const CODE = /^[a-z0-9]{4,32}$/i;

/** The friend's invite code in an address's query (`?ref=CODE`), if it is a well-formed one. */
export function referralCode(search: string): string | null {
  const code = new URLSearchParams(search).get("ref");
  return code && CODE.test(code) ? code : null;
}

export function captureReferral(search: string, now = Date.now()): void {
  const code = referralCode(search);
  if (!code) return;
  try {
    localStorage.setItem(KEY, JSON.stringify({ code: code.toLowerCase(), at: now }));
  } catch {
    // Private mode or blocked storage: the credit is simply lost.
  }
}

export function storedReferral(now = Date.now()): string | null {
  try {
    const saved = JSON.parse(localStorage.getItem(KEY) ?? "null") as {
      code?: string;
      at?: number;
    } | null;
    if (!saved?.code || !saved.at || now - saved.at > KEEP_MS || !CODE.test(saved.code)) {
      return null;
    }
    return saved.code;
  } catch {
    return null;
  }
}

export function clearReferral(): void {
  try {
    localStorage.removeItem(KEY);
  } catch {
    // Nothing to clear.
  }
}
